import ajax from "../utils/request";

const angentDistrictApi = {
  /*************************代理列表*************************/
  // 获取商区代理列表 or 下级代理  (共用接口，传参数不同)
  getDistrictList(params) {
    return ajax({
      url: "/district/list",
      type: "get",
      params: params,
    });
  },
  // 新增商区代理
  addDistrict(params) {
    return ajax({
      url: "/district/add",
      type: "post",
      params: params,
    });
  },

  //编辑---修改基础数据
  updateBase(params) {
    return ajax({
      url: "/district/update/update/base",
      type: "post",
      params: params,
    });
  },
  //编辑---修改充值配置
  updateDedRecharge(params) {
    return ajax({
      url: "/district/update/update/dedRecharge",
      type: "post",
      params: params,
    });
  },
  //编辑---修改用户配置
  updateDedNewUser(params) {
    return ajax({
      url: "/district/update/update/dedNewUser",
      type: "post",
      params: params,
    });
  },
  //编辑---修改落地页配置
  updateLandPage(params) {
    return ajax({
      url: "/district/update/update/ldy",
      type: "post",
      params: params,
    });
  },
  // // 编辑商区代理
  // updateDistrict(params) {
  //   return ajax({
  //     url: "/district/update",
  //     type: "post",
  //     params: params,
  //   });
  // },

  // 删除商区代理
  delDistrict(params) {
    return ajax({
      url: "/district/delete",
      type: "delete",
      params: params,
    });
  },
  /*** 禁用 */
  disDistrict(params) {
    return ajax({
      url: "/district/disable",
      type: "post",
      params: params,
    });
  },

  /*** 购买记录 */
  getPayHisList(params) {
    return ajax({
      url: "/district/agent/trans/BuyVip/list",
      type: "get",
      params: params,
    });
  },
  /** 每日统计  */
  getStatDailyList(params) {
    return ajax({
      url: "/district/agent/stat/daily/list",
      type: "get",
      params: params,
    });
  },
  /** 结算账单*/
  getStatSettlementList(params) {
    return ajax({
      url: "/district/agent/bill/list",
      type: "get",
      params: params,
    });
  },
  // 提现记录
  getWithdrawLists(params) {
    return ajax({
      url: "/district/agent/order/withdraw/list",
      type: "get",
      params: params,
    });
  },
  // 充值记录
  getRechargeList(params) {
    return ajax({
      url: "/district/agent/order/recharge/list",
      type: "get",
      params: params,
    });
  },
  //编辑--扣用户
  handleNewUserAnalysis(params) {
    return ajax({
      url: "/district/deduct/newUser/analysis",
      type: "post",
      params,
    });
  },
  //编辑--扣充值
  handleRechargeAnalysis(params) {
    return ajax({
      url: "/district/deduct/recharge/analysis",
      type: "post",
      params,
    });
  },
  //下级代理--添加
  addSubAgent(params) {
    return ajax({
      url: "/district/agent/add",
      type: "post",
      params: params,
    });
  },

  /************************* 代理权限*************************/
  //获取权限列表
  getRoleList(params) {
    return ajax({
      url: "/district/author/list",
      type: "get",
      params: params,
    });
  },
  // 新增权限列表
  addRole(params) {
    return ajax({
      url: "/district/author/add",
      type: "post",
      params: params,
    });
  },
  // 修改权限列表
  updateRole(params) {
    return ajax({
      url: "/district/author/update",
      type: "post",
      params: params,
    });
  },
  // 删除权限列表
  deleteRole(params) {
    return ajax({
      url: "/district/author/del",
      type: "delete",
      params: params,
    });
  },
  // 克隆权限
  clone(params) {
    return ajax({
      url: "/district/author/cloneToChild",
      type: "post",
      params: params,
    });
  },

  /************************* 每日报表*************************/
  // 获取每日报表列表
  getDailyList(params) {
    return ajax({
      url: "/district/agent/report/daily/list",
      type: "get",
      params: params,
    });
  },

  /************************* 每日报表*************************/
  // 获取每日报表列表
  getMonthlyList(params) {
    return ajax({
      url: "/district/agent/report/monthly/list",
      type: "get",
      params: params,
    });
  },

  /************************* 域名列表*************************/
  // 获取域名表列表
  getDomainList(params) {
    return ajax({
      url: "/district/domain/list",
      type: "get",
      params: params,
    });
  },
  // 修改域名
  updateDomain(params) {
    return ajax({
      url: "/district/domain/update",
      type: "post",
      params: params,
    });
  },
  // 删除域名
  delDomain(params) {
    return ajax({
      url: "/district/domain/del",
      type: "delete",
      params: params,
    });
  },
  //添加域名
  addDomain(params) {
    return ajax({
      url: "/district/domain/add",
      type: "post",
      params: params,
    });
  },

  /*********************广告审核**************************/
  // 请求广告审核列表
  getAdReviewList(params) {
    return ajax({
      url: "/district/ad/review/list",
      type: "get",
      params: params,
    });
  },
  //广告审核
  AdReview(params) {
    return ajax({
      url: "/district/ad/review/check",
      type: "post",
      params: params,
    });
  },
};

export default angentDistrictApi;
